module.exports = __webpack_public_path__ + "img/corporate1.3d4b222e.png";